import { DateTime } from 'luxon'
import { SVGName } from '~/ui/components/SVG'
import { CustomImage, RemoteImage, SVGImage } from './CustomImage'
import { Link } from './Link'
import { Model } from './Model'
import { datetime } from './serialization'
import { Page } from './Page'
import { Feed } from './Feed'

export class Project extends Model {

  public code!: string
  public name!: string
  public logo!: CustomImage

  @datetime()
  public startDate!: DateTime | null

  @datetime()
  public endDate!: DateTime | null

  public languages!:  string[]
  public features!:   ProjectFeature[]
  public tabs!:       ClientTab[]
  public web!:        WebConfig
  public homeScreen!: HomeScreenConfig

  public apnTopic!:  string | null
  public urlScheme!: string | null

  public feature(name: string) {
    const feature = this.features.find(f => f.name === name)
    if (feature == null || !feature.enabled) { return null }

    return feature
  }

  public afterDeserialize() {
    this.homeScreen.widgets = this.raw.homeScreen.widgets.map((widget: any) => {
      if (widget.type === 'menu-page' && widget.options.page != null) {
        widget.options.page = Page.deserialize(widget.options.page)
      }
      return widget
    })
  }

}

export interface WebConfig {
  layout: WebLayout
}

export type WebLayout = 'chat' | 'full'

export interface ProjectFeature {
  name:    string
  enabled: boolean
  options: AnyObject
}

export interface ClientTab {
  link:    Link
  caption: string
  icon:    {
    type:  'named'
    value: SVGName
  } | {
    type: 'custom'
    value: SVGImage
  }
}

export interface ProjectLocation {
  // The center coordinate of this Project's location.
  coordinate: {latitude: number, longitude: number}

  // The radius for the location.
  radius: number

  // An optional name for the location.
  name: string | null
}

export interface HomeScreenConfig {
  hero: {
    welcomeMessage: string | null
    search:         boolean
    background:     ImageBackground | VideoBackground
  }
  widgets: HomeScreenWidget[]
}

export type HomeScreenWidgetType = HomeScreenWidget['type']
export type HomeScreenWidget = AgendaHomeScreenWidget | MenuPageHomeScreenWidget | FeedHomeScreenWidget

export interface HomeScreenWidgetBase<T extends string, O extends Record<string, any>> {
  type:      T
  options:   O
}

export type AgendaHomeScreenWidget = HomeScreenWidgetBase<'agenda', any>

export type MenuPageHomeScreenWidget = HomeScreenWidgetBase<'menu-page', {
  page: Page
}>

export type FeedHomeScreenWidget = HomeScreenWidgetBase<'feed', {
  feed?: Feed
}>

export interface ImageBackground {
  type:   'image'
  image:  RemoteImage
  darken: boolean
  fade:   boolean
}

export interface VideoBackground {
  type:     'video'
  vimeoUrl: string
}